"use strict";
import { defineComponent } from "vue";
import App from "./app.class";
import FilterContainer from "@/study-search/presentation/components/filters/filter-container/FilterContainer.vue";
import MetaInfo from "./meta/MetaInfo.vue";
import ErrorPage from "./error/ErrorPage.vue";
import NavigationBar from "./navigation-bar/NavigationBar.vue";
import SearchBar from "./search-bar/SearchBar.vue";
import { Mobile } from "../../infrastructure/Mobile";
export default defineComponent({
  components: {
    FilterContainer,
    MetaInfo,
    ErrorPage,
    NavigationBar,
    SearchBar
  },
  setup: () => {
    const component = new App();
    return {
      isMobile: Mobile.instance.isMobile,
      isMastersPortal: component.isMastersPortal,
      isApplicationStatusError: component.isApplicationStatusError
    };
  }
});
